import { CL_FARMS_TABS } from "@/domains/cl-farms-page/constants"

import { ComplexBreadcrumbItem } from "../../types/complex-breadcrumb-item"
import { ComplexBreadcrumbDropdown } from "../complex-breadcrumb-dropdown"

export const ClFarmsPagesComplexBreadcrumbApplication: ComplexBreadcrumbItem = {
  type: "complex",
  application: "cl-farms-pages",
  render: () => <ClFarmsPagesComplexBreadcrumbApplicationComponent />,
}

/**
 * Complex breadcrumb application for CL Farms pages
 * Shows current page name and allows navigation to other CL Farms pages
 */
export const ClFarmsPagesComplexBreadcrumbApplicationComponent = () => {
  return (
    <ComplexBreadcrumbDropdown tabs={CL_FARMS_TABS} navigationMode="slug" invalidTabMessage="Invalid cl farms tab" />
  )
}
